module.exports = __webpack_public_path__ + "static/media/booking-delivered.5f333f3e.svg";